import React from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <Reveal className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-3xl'} data-id="element-45" data-mp="3k0p13e13ech9">
      <p className="font-tech text-xs font-semibold tracking-[0.32em] text-cyan/80" data-id="element-46" data-mp="blesdn2p690i">{eyebrow}</p>
      <h2 className="mt-4 font-display text-2xl leading-[1.25] text-white sm:text-3xl lg:text-[2.4rem]" data-id="element-47" data-mp="giewhsfzl1oz">
        {title}
      </h2>
      {description ? <p className="mt-4 text-base leading-relaxed text-white/55" data-id="element-48" data-mp="6tnae0xlxblz">{description}</p> : null}
      <div className={`mt-6 h-px w-40 hairline ${centered ? 'mx-auto' : ''}`} data-id="element-49" data-mp="uj7uin5hyewu" />
    </Reveal>;
}